import { forwardRef } from "react";
import { PinInput } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

export const CustomPinInput = forwardRef(({ size, ...props }, ref) => {
  const isDesktop = useIsDesktop();
  const responsiveSize = size ?? (isDesktop ? "lg" : "md");
  return <PinInput ref={ref} size={responsiveSize} {...props} />;
});

CustomPinInput.displayName = "CustomPinInput";
